import { lightYellow } from '@synoptic/ui-kit/palette.js';
import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const medalsCard = style({
  display: 'flex',
  gap: space.s10,
  borderRadius: borderRadius.r16,
  backgroundColor: themeVars.container.primary.background.idle,
  border: `1px solid ${themeVars.container.border.default}`,
  width: '100%',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  padding: `${space.s14}px ${space.s16}px`,

  ...responsiveStyle({
    mobile: {
      maxWidth: '350px',
    },
    tablet: {
      width: '235px',
    },
  }),
});

export const medalsHeader = style({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: space.s16,
});

export const headerTitle = style({
  ...typography['bodyMd'],
});

export const medalsOverLimitBadge = style([
  typography['labelMd'],
  {
    direction: 'ltr',
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: lightYellow[400],
    borderRadius: '100%',
  },
]);
